module.exports = __webpack_public_path__ + "static/media/event_card_2.567b2405.png";